import { render, staticRenderFns } from "./SparsImages.vue?vue&type=template&id=930dd624&scoped=true"
import script from "./SparsImages.vue?vue&type=script&lang=js"
export * from "./SparsImages.vue?vue&type=script&lang=js"
import style0 from "./SparsImages.vue?vue&type=style&index=0&id=930dd624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "930dd624",
  null
  
)

export default component.exports